import { MEMBERS_AREA } from '@wix/app-definition-ids';
import { getIsMaInstalled } from '../base-params/base-params-selectors';
import { MEMBER_SLUG_PARAM } from './constants';
import { noop } from 'lodash';
export const SET_MA_NAVIGATION = 'SET_MA_NAVIGATION';
const setMaNavigation = (payload) => ({
    type: SET_MA_NAVIGATION,
    payload,
});
export const initMaNavigation = () => (dispatch, getState, { wixCodeApi }) => {
    const isMaInstalled = getIsMaInstalled(getState());
    const baseUrl = wixCodeApi.location.baseUrl;
    isMaInstalled &&
        wixCodeApi.site
            .getPublicAPI(MEMBERS_AREA)
            .then((api) => Promise.all([api.getNavigatableRoles(), api.getMemberPagePrefix({ type: 'public' })]))
            .then(([navInfo, prefixInfo]) => {
            return dispatch(setMaNavigation({
                ...navInfo,
                profileLinkTemplate: `${baseUrl}/${prefixInfo.prefix}/${MEMBER_SLUG_PARAM}/${prefixInfo.prefix}`,
            }));
        })
            .catch(noop);
};
//# sourceMappingURL=ma-navigation-actions.js.map